import { Routes } from '@angular/router';
import { MAINTENANCE_WINDOW_PATH } from 'src/shared/constants/maintenance-window.constants';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { maintenanceGuard } from 'src/shared/guards/maintenance-window.guard';

export const trialsClinicRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((x) => x.LoginComponent),
    canActivate: [maintenanceGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('src/shared/components/authentication/trials-login/trials-login.component').then(
            (x) => x.TrialsLoginComponent
          ),
      },
    ],
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/verify-email/verify-email.component').then((x) => x.VerifyEmailComponent),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then((x) => x.OnboardingComponent),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'nouser',
    loadComponent: () => import('./pages/no-user/no-user.component').then((x) => x.NoUserComponent),
    canActivate: [maintenanceGuard, LoginGuard],
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then((x) => x.HomeComponent),
    title: 'Trials Clinic - Home',
    canActivate: [maintenanceGuard, LoginGuard],
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./pages/change-password/change-password.component').then((x) => x.ChangePasswordComponent),
    title: 'Trials Clinic - Change Password',
    canActivate: [maintenanceGuard, LoginGuard],
  },
  {
    path: 'user/:user_doc_id/pet/:pet_doc_id/trial/:trial_doc_id/step/:step_doc_id',
    loadComponent: () => import('./pages/call/call.component').then((x) => x.CallComponent),
    canActivate: [maintenanceGuard],
  },
  {
    path: MAINTENANCE_WINDOW_PATH,
    loadComponent: () =>
      import('src/shared/components/maintenance-window/maintenance-window-page/maintenance-window-page.component').then(
        (x) => x.MaintenanceWindowPageComponent
      ),
    title: 'Under Maintenance',
  },
  { path: '**', redirectTo: 'notfound' },
  {
    path: 'notfound',
    loadComponent: () => import('src/shared/components/notfound/notfound.component').then((x) => x.NotFoundComponent),
    canActivate: [maintenanceGuard],
    title: 'Trials Clinic - Page Not Found',
  },
];
